import { fromJS } from 'immutable';
import {
  ATTACH,
  ATTACH_CANCEL,
  BENCH,
  BENCH_CANCEL,
  END_ATTACH,
  END_BENCH,
  PUT_ACTIVE_POKEMON,
  END_PUT_BENCH_AS_ACTIVE_POKEMON,
  SWITCH_IN,
  END_SWITCH_IN,
  START_ATTACH,
  START_ATTACH_FLOW,
  START_BENCH,
  START_BENCH_FLOW, SET_ACTIVE_BENCH,
  END_EVOLVE,
  EVOLVE,
  EVOLVE_CANCEL,
  START_EVOLVE,
  START_EVOLVE_FLOW,
} from './constants';

export const startBenchFlow = (handPosition) => ({
  type: START_BENCH_FLOW,
  payload: fromJS({ handPosition }),
});

export const startBench = () => ({
  type: START_BENCH,
});

export const addToBench = (benchPosition) => ({
  type: BENCH,
  payload: fromJS({ benchPosition }),
});

export const addToBenchCancel = () => ({
  type: BENCH_CANCEL,
});

export const endBench = () => ({
  type: END_BENCH,
});

export const startAttachFlow = (attachCardPosition) => ({
  type: START_ATTACH_FLOW,
  payload: fromJS({ attachCardPosition }),
});

export const startAttach = () => ({
  type: START_ATTACH,
});

/** Attaches the energy being placed; `dragged` when it was dropped there, which waits with an Undo first. */
export const attach = (benchPosition = null, dragged = false) => ({
  type: ATTACH,
  payload: fromJS({ benchPosition, dragged }),
});

export const attachCancel = () => ({
  type: ATTACH_CANCEL,
});

export const endAttach = () => ({
  type: END_ATTACH,
});

export const putActivePokemon = (benchCardPosition) => ({
  type: PUT_ACTIVE_POKEMON,
  payload: fromJS({ benchCardPosition }),
});


export const endPutBenchAsActive = () => ({
  type: END_PUT_BENCH_AS_ACTIVE_POKEMON,
});

export const switchIn = (benchPosition) => ({
  type: SWITCH_IN,
  payload: fromJS({ benchPosition }),
});

export const endSwitchIn = () => ({
  type: END_SWITCH_IN,
});

export const setActiveBenchPosition = (benchPosition) => ({
  type: SET_ACTIVE_BENCH,
  payload: fromJS({ benchPosition }),
});

/** Evolving starts from an evolution card in the hand; the Pokémon it can go on light up. */
export const startEvolveFlow = (evolveCardPosition) => ({
  type: START_EVOLVE_FLOW,
  payload: fromJS({ evolveCardPosition }),
});

export const startEvolve = () => ({
  type: START_EVOLVE,
});

/** @param {number|null} benchPosition null for the active Pokémon */
export const evolve = (benchPosition = null) => ({
  type: EVOLVE,
  payload: fromJS({ benchPosition }),
});

export const evolveCancel = () => ({
  type: EVOLVE_CANCEL,
});

export const endEvolve = () => ({
  type: END_EVOLVE,
});
